<template>
  <div class="tax-section">
    <h6 class="section-label mt-0">
      <feather-icon icon="CalendarIcon" size="13" class="mr-50" />Sale Details
    </h6>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label>Selling Price</label>
          <b-input-group prepend="฿">
            <b-form-input
              :value="formatNumber(salePrice)"
              @input="v => $emit('update:salePrice', parseNumber(v))"
              type="text"
              placeholder="Selling Price"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label class="d-block">Seller Type</label>
          <b-form-radio-group
            v-model="sellerTypeModel"
            :options="[
              { text: 'Individual', value: 'individual' },
              { text: 'Juristic (Company)', value: 'juristic' },
            ]"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group class="mb-0">
          <label>
            Date Acquired (พ.ศ.)
            <span v-if="dateAcquired" class="text-muted font-weight-normal">
              {{ formatGregorian(dateAcquired) }}
            </span>
          </label>
          <thai-date-picker v-model="dateAcquiredModel" :max="today" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group class="mb-0">
          <label>
            Transfer Date (พ.ศ.)
            <span v-if="transferDate" class="text-muted font-weight-normal">
              {{ formatGregorian(transferDate) }}
            </span>
          </label>
          <thai-date-picker v-model="transferDateModel" :min="dateAcquired" />
        </b-form-group>
      </b-col>
    </b-row>

    <small v-if="dateAcquired" class="text-muted d-block mt-1">
      Holding period as of transfer date: {{ holdingYears }} year(s)
    </small>
    <small v-if="dateAcquired && sellerType === 'individual'" class="text-muted d-block">
      Calendar year used for tax calc (capped at 10): {{ calendarYear }} year(s)
    </small>

    <b-form-group v-if="sellerType === 'individual'" class="mb-0 mt-1">
      <label class="d-block">House Registration (ทะเบียนบ้าน)</label>
      <b-form-radio v-model="isPrimaryResidenceExemptModel" :value="true" name="house-reg" class="mb-1">
        Owner has registered its name in a House Registration Book (Blue Book) totally more than 1 year
      </b-form-radio>
      <b-form-radio v-model="isPrimaryResidenceExemptModel" :value="false" name="house-reg">
        Owner has never registered or registered its name in a House Registration Book (Blue Book) less than 1 year
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BInputGroup, BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import { formatNumber, parseNumber, formatGregorian } from '../format'
import ThaiDatePicker from '../ThaiDatePicker.vue'

export default {
  components: {
    BRow, BCol, BFormGroup, BFormInput, BInputGroup, BFormRadioGroup, BFormRadio, ThaiDatePicker,
  },
  props: {
    salePrice: { type: Number, default: null },
    sellerType: { type: String, required: true },
    dateAcquired: { type: String, default: null },
    transferDate: { type: String, default: null },
    isPrimaryResidenceExempt: { type: Boolean, default: false },
    today: { type: String, required: true },
    holdingYears: { type: Number, default: 0 },
    calendarYear: { type: Number, default: 0 },
  },
  computed: {
    sellerTypeModel: {
      get() { return this.sellerType },
      set(value) { this.$emit('update:sellerType', value) },
    },
    dateAcquiredModel: {
      get() { return this.dateAcquired },
      set(value) { this.$emit('update:dateAcquired', value) },
    },
    transferDateModel: {
      get() { return this.transferDate },
      set(value) { this.$emit('update:transferDate', value) },
    },
    isPrimaryResidenceExemptModel: {
      get() { return this.isPrimaryResidenceExempt },
      set(value) { this.$emit('update:isPrimaryResidenceExempt', value) },
    },
  },
  methods: {
    formatNumber,
    parseNumber,
    formatGregorian,
  },
}
</script>
